import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { WebLink } from '@/components/functional/Link/WebLink';
import { Checkbox } from '@/components/ui/Form/Checkbox';
import { linkTextStyle } from '@/components/ui/Typography/Body/LinkText/style';
/**
 * 同意確認チェックボックス
 */
export const CheckboxAgreement = (props) => {
    const { checked, className = '', linkText, onChange, target = '_blank', to, } = props;
    return (_jsx(Checkbox, { checked: checked, className: className, label: _jsxs(_Fragment, { children: [_jsx(WebLink, Object.assign({ className: linkTextStyle(), target: target, to: to }, { children: linkText })), _jsx("span", { children: "\u306B\u540C\u610F\u3059\u308B" })] }), onChange: onChange }));
};
